
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/addPreset/addSection/components/aiSectionCreator/components/resultsDisplay.scss.css.virtualfile';
        module.exports = {"controls":"_controls_1tvru_1","controls-title":"_controls-title_1tvru_6","controlsTitle":"_controls-title_1tvru_6"};